export enum SequelizeMetaColumns {
    name = 'name',
}

export interface SequelizeMetaAttributes {
    name: string;
}

export type SequelizeMetaCreate = SequelizeMetaAttributes;
